import { render, staticRenderFns } from "./PageContentUpdate.vue?vue&type=template&id=639b4a06"
import script from "./PageContentUpdate.vue?vue&type=script&lang=ts"
export * from "./PageContentUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports